module.exports = __webpack_public_path__ + "img/xc_banner.e5145f9.jpg";